import React from "react";
import { ISuburbReportPack } from "./suburbReportsData";

interface SuburbReportPackCardProps {
  pack: ISuburbReportPack;
}

const SuburbReportPackCard: React.FC<SuburbReportPackCardProps> = ({ pack }) => {
  const columnGridClass = pack.reportGroups.length > 1 ? "sm:grid-cols-2 lg:grid-cols-3" : "sm:grid-cols-2";

  return (
    <div className="rounded-xl border border-slate-100 bg-slate-50/50 p-4 md:p-5 transition-all hover:border-slate-200 hover:bg-slate-50 hover:shadow-sm">
      {pack.intro && <p className="text-sm md:text-base leading-relaxed text-slate-700 mb-6">{pack.intro}</p>}

      <div className={`grid grid-cols-1 ${columnGridClass} gap-8`}>
        <div className="md:col-span-1">
          <h4 className="text-xl md:text-[1.7rem] font-semibold text-black mb-5 md:mb-6 tracking-wide">Key Benefits</h4>

          {pack.benefitsDescription && (
            <p className="text-sm md:text-base leading-relaxed text-slate-700 mb-5">{pack.benefitsDescription}</p>
          )}

          <ul className="grid grid-cols-1 gap-4 text-slate-700">
            {pack.benefits.map((benefit, index) => (
              <li
                key={`${pack.id}-benefit-${index}`}
                className="flex items-start gap-4 rounded-2xl border border-slate-100 bg-slate-50/50 p-4 md:p-5 transition-all hover:border-emerald-200 hover:bg-emerald-50/30 group"
              >
                <span className="inline-flex items-center justify-center h-8 w-8 rounded-full bg-emerald-100 text-emerald-700 font-bold shrink-0 transition-transform group-hover:scale-110">
                  ✓
                </span>
                <span className="text-sm md:text-base leading-relaxed">{benefit}</span>
              </li>
            ))}
          </ul>
        </div>

        {pack.reportGroups.map((group, groupIndex) => (
          <div key={`${pack.id}-${group.heading}`}>
            <h4 className="text-xl md:text-[1.7rem] font-semibold text-black mb-5 md:mb-6 tracking-wide">
              {group.heading}
            </h4>

            <ul className="space-y-2 list-none p-0">
              {group.links.map((link, index) => (
                <li key={`${pack.id}-${group.heading}-link-${index}`}>
                  <a
                    id={`srpc-lnk-download-${pack.id}-${groupIndex}-${index}`}
                    data-testid={`srpc-lnk-download-${pack.id}-${groupIndex}-${index}`}
                    href={link.href}
                    target="_blank"
                    rel="noreferrer"
                    className="group flex items-center gap-3 p-2 -ml-2 rounded-lg hover:bg-white hover:shadow-sm hover:ring-1 hover:ring-slate-100 transition-all duration-200"
                  >
                    <span className="flex-shrink-0 w-8 h-8 rounded-lg bg-white border border-slate-200 text-slate-400 group-hover:text-[var(--primary-color)] group-hover:border-[var(--primary-color)] flex items-center justify-center transition-colors">
                      <i className="pi pi-download text-xs" />
                    </span>
                    <div>
                      <span className="block text-sm md:text-base font-medium text-slate-700 group-hover:text-[var(--primary-color)] transition-colors leading-tight">
                        {link.label}
                      </span>
                    </div>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SuburbReportPackCard;
